import { render, staticRenderFns } from "./OrganisationPage.vue?vue&type=template&id=d064cfda&scoped=true"
import script from "./OrganisationPage.vue?vue&type=script&lang=ts"
export * from "./OrganisationPage.vue?vue&type=script&lang=ts"
import style0 from "./OrganisationPage.vue?vue&type=style&index=0&id=d064cfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d064cfda",
  null
  
)

export default component.exports